module.exports = __webpack_public_path__ + "static/media/pastabeker.43a21a3d.jpg";